import { yup } from '@guiker/shared-framework'

export const exportSchema = yup.object<{
  balanceAt: string
}>({
  balanceAt: yup.string().required(),
})
